import React, { useState } from 'react';
import { changePassword } from '../api/auth';
import { TextField, Button, Container, Typography, Alert, Box } from '@mui/material';
import ContextHelpButton from '../components/ContextHelpButton';

export default function ChangePasswordPage() {
  const [form, setForm] = useState({ old_password: '', new_password: '' });
  const [submitting, setSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [error, setError] = useState(null);
  const token = localStorage.getItem('access_token');

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setSuccessMsg('');

    try {
      await changePassword(form, token);
      setSuccessMsg('Your password has been updated successfully.');
      setForm({ old_password: '', new_password: '' });
    } catch (err) {
      setError(err?.response?.data?.detail || err?.response?.data?.error || 'Unable to update password. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5">Change Password</Typography>
        <ContextHelpButton section="getting-started" title="Help for changing your password" />
      </Box>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {successMsg && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {successMsg}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <TextField
          fullWidth
          label="Old Password"
          name="old_password"
          type="password"
          onChange={handleChange}
          margin="normal"
          value={form.old_password}
          required
        />
        <TextField
          fullWidth
          label="New Password"
          name="new_password"
          type="password"
          onChange={handleChange}
          margin="normal"
          value={form.new_password}
          required
        />
        <Button type="submit" variant="contained" disabled={submitting || !form.old_password || !form.new_password}>
          {submitting ? 'Updating...' : 'Update Password'}
        </Button>
      </Box>
    </Container>
  );
}
